import { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const MEETINGS = [
  { key: 'meeting_monthly', label: 'මාසික මහසභා රැස්වීම' },
  { key: 'meeting_annual', label: 'සංවත්සර මහසභා රැස්වීම' },
  { key: 'meeting_special', label: 'විශේෂ මහසභා රැස්වීම' },
];

const OPTIONS = [
  { value: 'present', label: 'Present' },
  { value: 'absent', label: 'Absent' },
];

export default function Meetings({ member }) {
  const [form, setForm] = useState({
    meeting_monthly: '',
    meeting_annual: '',
    meeting_special: '',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!member) return;
    setForm({
      meeting_monthly: member.meeting_monthly || '',
      meeting_annual: member.meeting_annual || '',
      meeting_special: member.meeting_special || '',
    });
  }, [member]);

  const setField = key => e => setForm(p => ({ ...p, [key]: e.target.value }));

  const save = async () => {
    if (!member?.id) { toast.error('Save personal info first'); return; }
    setSaving(true);
    try {
      await api.put(`/members/${member.id}`, form);
      toast.success('Meeting attendance saved');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (!member?.id) {
    return <div className="empty-state"><p>Save personal info first to manage meeting attendance.</p></div>;
  }

  return (
    <div style={{ display: 'grid', gap: 18 }}>
      <div className="card" style={{ padding: 18 }}>
        <h3 style={{ marginBottom: 18 }}>Meeting Attendance</h3>
        <div className="grid-3">
          {MEETINGS.map(meeting => (
            <div className="form-group" key={meeting.key}>
              <label className="form-label">{meeting.label}</label>
              <select className="form-select" value={form[meeting.key]} onChange={setField(meeting.key)}>
                <option value="">— Select —</option>
                {OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
              </select>
            </div>
          ))}
        </div>
      </div>
      <div className="section-save-bar">
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : 'Save Attendance'}
        </button>
      </div>
    </div>
  );
}
